import styled from 'styled-components';
import Container from 'ui/atoms/container';
import { resolveColor } from 'ui/styles/utils/colors';
import { query } from 'ui/styles/queries';

export const WizardLayout = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => resolveColor(theme, 'background')};
  overflow: hidden;
  padding: 1.5rem 2rem;
`;
export const WizardContent = styled.div`
  flex-grow: 1;
  height: 100%;
  height: -webkit-fill-available;
  overflow: auto;
  background-color: ${({ theme }) => resolveColor(theme, 'white')};
  border-radius: 1rem;

  ${query.phone`
    border-radius: 0;
  `};
`;

export const Header = styled.header`
  position: sticky;
  top: 0;
  z-index: ${({ theme }) => theme.zIndices.header};
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
`;

export const Main = styled.main`
  position: relative;
  height: 100%;
`;
export const Footer = styled.footer`
  height: 20px;
  line-height: normal;
  margin-top: 1rem;

  ${query.phone`
    margin-left: 1rem;
  `};
`;

export const SidebarElements = styled(Container)`
  position: relative;
`;
